var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfFeatures = function SvgPdfFeatures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 21.5v-1.192H6V19.25H4.5v-1.192H6V17H3.5v-1.192h2.846q.36 0 .603.243a.82.82 0 0 1 .243.603v1.192q0 .36-.243.603a.82.82 0 0 1-.603.243q.36 0 .603.244a.82.82 0 0 1 .243.602v1.116q0 .36-.243.603a.82.82 0 0 1-.603.243zm0-6.654V12.25q0-.36.243-.603a.82.82 0 0 1 .603-.243H6v-1.058H3.5V9.154h2.846q.36 0 .603.243a.82.82 0 0 1 .243.603v1.75a.82.82 0 0 1-.243.603.82.82 0 0 1-.603.243H4.692v1.058h2.5v1.192zM5 8.192v-4.5H3.5V2.5h2.692v5.692zM9.308 18.75v-1.5H20.5v1.5zm0-6v-1.5H20.5v1.5zm0-6v-1.5H20.5v1.5z"
  })));
};
export default SvgPdfFeatures;